/* eslint-disable */

import {
  Dialog,
  DialogActions,
  DialogTitle,
  makeStyles,
} from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import { Visibility } from "@material-ui/icons";
import Search from "@material-ui/icons/Search";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput";
import Select from "components/Select/Select";
import TablePaginate from "components/TablePaginate/TablePaginate";
import PropTypes from "prop-types";
import React, { useCallback, useState } from "react";
import { Link } from "react-router-dom";
import { swapService } from "services/swapService";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import { chainOptions } from "const";

const FE_LINK = process.env.REACT_APP_FE_LINK;

const useStyles = makeStyles({
  filter: {
    display: "flex",
    gap: "40px",
  },
});

export default function SwapIndex() {
  const classes = useStyles();
  const [items, setItems] = React.useState([]);
  const [search, setSearch] = React.useState("");
  const [status, setStatus] = React.useState("");
  const [page, setPage] = React.useState(0);
  const [size] = React.useState(10);
  const [count, setCount] = React.useState(0);
  const [open, setOpen] = useState(false);
  const [isImport, setIsImport] = useState(false);
  const [isRefresh, setIsRefresh] = useState(false);
  const [chainId, setChainId] = React.useState("-1");

  const handleOpen = useCallback(() => setOpen(true), []);
  const handleClose = useCallback(() => {
    setOpen(false);
    setIsImport(!isImport);
  }, [isImport]);

  const getChainById = (id) => {
    const chain = chainOptions().find((c) => +c.value === +id);
    return chain ? chain.label : "Null";
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Swap ID",
        accessor: "swapId",
      },
      {
        Header: "Chain",
        accessor: "chainId",
        Cell: function Tier(cell) {
          return getChainById(cell.value);
        },
      },
      {
        Header: "Hash",
        accessor: "hash",
      },
      {
        Header: "Action",
        Cell: function remove({ cell }) {
          return (
            <>
              <Action setItems={setItems} cell={cell}></Action>
            </>
          );
        },
      },
    ],
    [handleClose, isImport, open]
  );

  const handleRefresh = useCallback(() => {
    setIsImport(!isImport);
    setIsRefresh(true);
  }, [isImport, isRefresh]);

  async function fetchSwap() {
    const payload = {
      page,
      size,
      sortBy: "order",
      sortType: "asc",
      search: search,
      swapId: search ? +search : undefined,
      finished: status ? true : false,
      chainId: +chainId,
    };
    if (!payload.chainId || payload.chainId === -1) delete payload.chainId;

    try {
      const { data } = await swapService.list(payload);
      setItems(data.items);
      setCount(data.paginate.count);
      setPage(data.paginate.page);
      setIsRefresh(false);
    } catch (e) {
      console.log(e);
    }
  }

  React.useEffect(() => {
    fetchSwap();
  }, [page, search, status, isImport, chainId]);

  return (
    <div>
      {confirm}

      <div className={classes.filter}>
        <CustomInput
          labelText="Search by swap id, user address or token address"
          id="search"
          formControlProps={{
            fullWidth: true,
          }}
          inputProps={{
            value: search,
            onChange: (e) => setSearch(e.target.value),
            endAdornment: (
              <InputAdornment position="end">
                <Search />
              </InputAdornment>
            ),
          }}
        />

        <Select
          label={"Status"}
          value={status}
          onChange={setStatus}
          options={[
            { value: undefined, label: "ALL" },
            { value: true, label: "Finished" },
            { value: false, label: "Un Finished" },
          ]}
        />
        <Select
          label={"Chain"}
          value={chainId}
          onChange={setChainId}
          options={[{ value: "-1", label: "All" }, ...chainOptions()]}
        />
      </div>

      <TablePaginate
        count={count}
        page={page}
        setPage={setPage}
        size={size}
        columns={columns}
        data={items}
      />
    </div>
  );
}

function Action({ setItems, cell }) {
  const [openDialogDel, setOpenDialogDel] = React.useState(false);

  const handleClickOpen = () => {
    setOpenDialogDel(true);
  };

  const handleClose = () => {
    setOpenDialogDel(false);
  };

  const deleteNft = async (id) => {
    await swapService.remove(id);
    setItems((prev) => prev.filter((x) => x._id !== id));
    handleClose();
  };

  return (
    <div
      className="actions-right"
      style={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        gap: "10px",
      }}
    >
      <Link to={"/admin/swap/" + cell.row.original._id}>
        <Button justIcon round simple color="success" className="edit">
          <VisibilityIcon />
        </Button>
      </Link>

      <div>
        <DeleteIcon
          onClick={() => handleClickOpen()}
          style={{ fontSize: "20px", color: "#ce2727", cursor: "pointer" }}
        />

        <Dialog
          open={openDialogDel}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Confirm Delete Swap"}
          </DialogTitle>
          <DialogActions>
            <Button onClick={handleClose} color="transparent">
              Cancel
            </Button>
            <Button
              onClick={() => deleteNft(cell.row.original._id)}
              color="success"
            >
              Agree
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
}

Action.propTypes = {
  cell: PropTypes.any,
  setItems: PropTypes.any,
};

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

function View({ cell }) {
  return (
    <div className="actions-right">
      <Link to={"/admin/collection/" + cell.row.original.id}>
        <Button justIcon round simple color="success" className="edit">
          <Visibility />
        </Button>
      </Link>
    </div>
  );
}

View.propTypes = {
  cell: PropTypes.any,
};
